module.exports = __webpack_public_path__ + "img/app.f99af8cc.png";